const transactions = [
  {
    id: "TXN-88231",
    type: "Debit",
    title: "Payment for EV Battery Enclosure v2",
    reference: "ORD-2411-0142",
    date: "Nov 11, 2026",
    method: "Wallet",
    amount: 63200,
    status: "Completed",
    statusColor: "bg-green-100 text-green-700",
  },
  {
    id: "TXN-88214",
    type: "Credit",
    title: "Wallet Top-up",
    reference: "UPI · arjun@okhdfc",
    date: "Nov 10, 2026",
    method: "UPI",
    amount: 75000,
    status: "Completed",
    statusColor: "bg-green-100 text-green-700",
  },
  {
    id: "TXN-88190",
    type: "Debit",
    title: "Payment for Agri Drone Chassis",
    reference: "ORD-2411-0138",
    date: "Nov 13, 2026",
    method: "Wallet",
    amount: 48750,
    status: "Completed",
    statusColor: "bg-green-100 text-green-700",
  },
  {
    id: "TXN-87965",
    type: "Credit",
    title: "Wallet Top-up",
    reference: "Card · HDFC •• 4821",
    date: "Oct 28, 2026",
    method: "Card",
    amount: 40000,
    status: "Completed",
    statusColor: "bg-green-100 text-green-700",
  },
  {
    id: "TXN-87801",
    type: "Debit",
    title: "Payment for Smart Helmet Shell",
    reference: "ORD-2410-0098",
    date: "Oct 01, 2026",
    method: "Wallet",
    amount: 19800,
    status: "Completed",
    statusColor: "bg-green-100 text-green-700",
  },
  {
    id: "TXN-87622",
    type: "Debit",
    title: "Payment for IoT Smart Water Sensor",
    reference: "QT-2411-0129",
    date: "Nov 20, 2026",
    method: "Net Banking",
    amount: 21400,
    status: "Pending",
    statusColor: "bg-orange-100 text-orange-700",
  },
];

export default transactions;